import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const AUTH_REFRESH = new InjectionToken<() => Observable<void>>('AUTH_REFRESH');
